module.exports = __webpack_public_path__ + "img/soundSportFree.fb88f334.png";